/**
 * Resolve the specification a public `?s=` link refers to.
 *
 * Public links carry the *external* ChrisRussellNG specification id, while the
 * configurator API also exposes the internal OfferSpecification id as `id`.
 * Both are small integers, so matching on `id` can silently resolve to a
 * different variant than the link intended. Match on the external id first and
 * only fall back to `id` for specifications that have no external mapping.
 *
 * @param {Specification[]} specifications
 * @param {number} specificationId
 * @returns {Specification|undefined}
 */
export const findSpecificationById = (specifications, specificationId) => {
	const byExternalId = specifications.find(s => s.externalId === specificationId);

	if (byExternalId) {
		return byExternalId;
	}

	return specifications.find(s => !s.externalId && s.id === specificationId);
};



// WEBPACK FOOTER //
// ./src/helpers/specification/findSpecificationById.js